import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	token: '064d6d3f-8366-4388-ae35-fe6f200fa2d8',
	culture: {
		base: 'Default',
		default: 'en-GB',
	},
	core: {
		serviceUrl: 'https://api-rel.fundpress.io',
		skeletonLoaders: {
			variables: [
				{
					key: 'fillColor',
					value: '#dddddd',
				},
			],
			loaders: [
				{
					id: 'ksys-app-start',
					breakpoints: [
						{
							minWidthInPixels: 0,
							style: {
								height: '86px',
							},
							children: [
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '11.90625px',
									'height': '28px',
									'width': '100%',
								},
								{
									'fill': '{fillColor}',
									'x': '0px',
									'y': '59.8125px',
									'height': '18px',
									'width': '100%',
								},
							],
						},
					],
				},
			],
		},
	},
	data: {
		context: {
			entityByType: {
				FUND: {
					inputKey: 'fundId',
					clientCodeProperty: 'fund_code',
					include: {
						commentaries: {},
					},
				},
				CLSS: {
					inputKey: 'isin',
					clientCodeProperty: 'isin',
					include: {
						commentaries: {},
					},
				},
			},
		},
	},
	components: {
		app: {
			disabledActions: [
			],
		},
		userDetail: {
			cardProps: {
				title: 'User Details',
				subtitle: 'Suspendisse cras pulvinar fringilla nec habitasse urna, platea ultrices. Ipsum cras ultrices varius mauris et in lorem.',
			},
			saveUserDetailButtonText: 'Save Details',
			userDetailNameLabelText: 'Full Name',
			userDetailEmailLabelText: 'Email',
		},
		resetPassword: {
			cardProps: {
				title: 'Password Reset',
				subtitle: 'Suspendisse cras pulvinar fringilla nec habitasse urna, platea ultrices. Ipsum cras ultrices varius mauris et in lorem. ',
			},
			resetPasswordButtonText: 'Reset Password',
			successMessage: 'If your user exists, you should receive an email with more information, please follow the instructions listed there',
			errorMessage: 'An error occurred while processing this request. Please contact your administrator',
			userNameNotFoundErrorMessage: 'The user name could not be found.',
		},
		mfaSetup: {
			cardProps: {
				title: 'Two-Factor Authentication',
				subtitle: 'Suspendisse cras pulvinar fringilla nec habitasse urna, platea ultrices. Ipsum cras ultrices varius mauris et in lorem. ',
			},
			displayType: 'drilldown',
		},
		assurance: {
			cardProps: {
				title: 'Assurance',
				subtitle: 'Suspendisse cras pulvinar fringilla nec habitasse urna, platea ultrices. Ipsum cras ultrices varius mauris et in lorem. ',
			},
			assuranceMessageLabelText: 'Message',
			assuranceImagePickerLabelText: 'Image:',
		},
	},
};
